import { round } from "lodash";
import { UNITS } from "../constants";

const mapKeyFn = x =>
	JSON.stringify({
		lat: round(x.location.lat(), 5),
		lng: round(x.location.lng(), 5)
	});

const cacheArgFn = x =>
	JSON.stringify({
		lat: round(x.lat, 5),
		lng: round(x.lng, 5)
	});

function mapHelpers($q, dataloader) {
	const elevator = new window.google.maps.ElevationService();

	this.elevationLoader = dataloader.newLoader(latLng => getElevation(latLng), {
		wait: 1000,
		limit: 512,
		mapKeyFn,
		cacheArgFn
	});

	function getElevation(latLngObjs) {
		return $q((res, rej) => {
			const params = { locations: latLngObjs };
			elevator.getElevationForLocations(params, onSuccess);
			
			function onSuccess(results, status) {
				if(status === "OK" && results[0]) {
					const enhancedResults = [];
					for(const result of results) {
						const enhancedResult = {
							...result,
							isAboveSeaLevel: result.elevation > 0,
							rawValue: parseFloat(result.elevation),
							meters: Math.abs(parseFloat(result.elevation)),
							feet: Math.abs(parseFloat(result.elevation)) * UNITS.feet.per.meter	
						};
						enhancedResults.push(enhancedResult);
					}
					res(enhancedResults);
				} else {
					rej("Elevation service failed due to: " + status);
				}
			}
		});
	}
}

export default angular
	.module("vesl.services.map-helpers", [])
	.service("mapHelpers", mapHelpers).name;
